import React from 'react';
import { connect } from 'react-redux';
import { Dialog } from '@mui/material';
import { IAppState } from '../../../state/reducers';
import { IDispatchProps, IProps, IStateProps } from './interfaces';
import VendorConsentSettings from './VendorConsentSettings/component';
import { toggleVendorConsentSettings } from '../../../state/exchange/vendorConsentSettings';

class ExchangeVendorConsentSettingsDialog extends React.Component<IProps> {
  render() {
    const {
      isOpen,
      onClose,
    } = this.props;

    return (
      <Dialog
        open={isOpen}
        onClose={onClose}
        fullWidth
        maxWidth="sm"
      >
        <VendorConsentSettings />
      </Dialog>
    );
  }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  isOpen: state.exchange.vendorConsentSettings.isOpen,
});

const mapDispatchToProps: IDispatchProps = {
  onClose: toggleVendorConsentSettings,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExchangeVendorConsentSettingsDialog);
